import apiClient from '../Core/apiClient';
import API_ROUTES from '../../ConfigFiles/Routes/api_routes';
import type { UserRead } from '../../Types/schema-helpers'; 

export interface LoginResponse {
  success: boolean;
  user: UserRead;
}

export default class AuthService {
  /**
   * Authenticates user against FastAPI OAuth2 endpoint using standard URLSearchParams
   */
  static async login(username: string, password: string): Promise<LoginResponse> {
    const data = new URLSearchParams({
      username,
      password,
    });
    
    try {
      const response = await apiClient.post<UserRead>(API_ROUTES.login, data, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      if (response.status === 200 && response.data) {
        return { success: true, user: response.data };
      }
      
      throw new Error(`Login failed with status: ${response.status}`);
    } catch (error) {
      console.error('Login failed:', error);
      throw error; 
    }
  }
  
  /**
   * Logs out user and guarantees local storage session key cleanup
   */
  static async logout(): Promise<boolean> {
    try {
      await apiClient.post(API_ROUTES.logout, {});
      return true;
    } catch (error) {
      console.error('Logout failed:', error);
      return false;
    } finally {
      localStorage.removeItem('session_exists');
    }
  }
}